
import { mapActions, mapState, mapGetters } from "vuex";
import dialogCloseBtn from "../common/dialog-close-btn.vue";
import ConfirmationDialog from "./confirmation-dialog.vue";

export default {
  components: { dialogCloseBtn, ConfirmationDialog },
  data() {
    return {
      printerObj: {},
      selectedPrinter: "",
      nickName: "",
      menuLoading: false,
      availablePrinters: [],
      loading: false,
      menuItemsToDisplay: [],
      tab: 0,
      deleteConfirmationDialog: false
    };
  },
  props: {
    dialog: false,
    printer: "",
    availableUnusedPrinters: {
      default: []
    }
  },
  mounted() {
    this.initAddNewItem();
    this.printerObj = this.printers.find((el) => el.id == this.printer);
    this.selectedPrinter = this.printerObj.name;
    this.nickName = this.printerObj.nickname;

    this.availablePrinters = JSON.parse(
      JSON.stringify(this.availableUnusedPrinters)
    );
    this.availablePrinters.push(this.printerObj);
    this.menuItemsToDisplay = this.parseItemObj(
      this.getPrinterAssignedItems(this.printer)
    );
  },
  computed: {
    ...mapState("restaurant", ["printers", "locationDetails"]),
    ...mapState("menu", ["menuItems"]),
    ...mapGetters("menu", ["getPrinterAssignedItems"])
  },
  watch: {
    menuItems: {
      handler() {
        this.menuItemsToDisplay = this.parseItemObj(
          this.getPrinterAssignedItems(this.printer)
        );
      }
    }
  },
  methods: {
    ...mapActions("menu", ["getMenuList"]),
    ...mapActions("restaurant", [
      "updatePrinter",
      "getLocationPrinters",
      "deletePrinter"
    ]),

    parseItemObj(itemList) {
      return itemList.map((el) => {
        return {
          id: el.id,
          item_name: el.item_name,
          printer_id: el.printer_id,
          selected: !!el.printer_id
        };
      });
    },
    async initAddNewItem() {
      this.menuLoading = true;
      try {
        await this.getMenuList(false);
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.menuLoading = false;
    },
    async unassignItem(item) {},
    async handleModifyPrinter() {
      this.loading = true;
      try {
        await this.updatePrinter({
          printer: this.printer,
          payload: {
            printer: { nickname: this.nickName, name: this.selectedPrinter }
          }
        });
        this.getLocationPrinters({
          id: this.locationDetails.id,
          forceFetch: true
        });
        this.$nuxt.$emit("show-toast", {
          text: "Printer modified successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.$emit("close-dialog");
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.loading = false;
    },
    async handleDeletePrinter() {
      this.deleteConfirmationDialog = false;
      this.deleteLoading = true;
      try {
        await this.deletePrinter({
          printer: this.printer
        });
        this.getLocationPrinters({
          id: this.locationDetails.id,
          forceFetch: true
        });
        this.$nuxt.$emit("show-toast", {
          text: "Printer deleted successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.$emit("close-dialog");
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.deleteLoading = false;
    }
  }
};
